import React, { useEffect, useState } from 'react';
import ArrowCircleFullRight from '../../../assets/icons/ArrowCircleFullRight';
import ArrowCircleLeft from '../../../assets/icons/ArrowCircleLeft';
import { PageDiv, Container } from './styles';

const Pagination = ({
  style = {},
  numberOfPages,
  onPageChange, //setPage
  actualPage,
}) => {
  const [allPages, setAllPages] = useState([]);

  useEffect(() => {
    switch (true) {
      case numberOfPages < 7:
        setAllPages([...new Array(numberOfPages)].map((_, i) => i + 1));
        break;
      case actualPage < 4:
        setAllPages([1, 2, 3, 4, 5, '...', numberOfPages]);
        break;
      case actualPage > numberOfPages - 4:
        setAllPages([
          1,
          '...',
          numberOfPages - 4,
          numberOfPages - 3,
          numberOfPages - 2,
          numberOfPages - 1,
          numberOfPages,
        ]);
        break;
      default:
        setAllPages([
          1,
          '...',
          actualPage - 1,
          actualPage,
          actualPage + 1,
          '...',
          numberOfPages,
        ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualPage, numberOfPages]);

  return (
    <Container style={style}>
      {actualPage === 1 ? (
        <ArrowCircleLeft
          style={{ cursor: 'pointer', marginRight: '0.34rem' }}
        />
      ) : (
        <ArrowCircleFullRight
          onClick={() => onPageChange(actualPage - 1)}
          style={{
            zIndex: 9,
            cursor: 'pointer',
            transform: 'rotate(180deg)',
            marginRight: '0.34rem',
          }}
        />
      )}
      {allPages.map((item, index) => (
        <PageDiv
          key={index}
          active={item === actualPage}
          onClick={() =>
            item !== actualPage && item !== '...' && onPageChange(item)
          }
        >
          {item}
        </PageDiv>
      ))}

      {actualPage >= numberOfPages ? (
        <ArrowCircleLeft
          style={{
            cursor: 'pointer',
            transform: 'rotate(180deg)',
            marginLeft: '1.14rem',
          }}
        />
      ) : (
        <ArrowCircleFullRight
          onClick={() => onPageChange(actualPage + 1)}
          style={{
            zIndex: 9,
            cursor: 'pointer',
            marginLeft: '1.14rem',
          }}
        />
      )}
    </Container>
  );
};

export default Pagination;
